// extracted by mini-css-extract-plugin
module.exports = {"badgesContainer":"Badges-module--badgesContainer--374mY","badge":"Badges-module--badge--6iIqv"};